import { OpaqueType } from '../../../opaque-internal/src/OpaqueType.esm.js';

const OpaqueExtensionDefinition = OpaqueType.create({
  type: "@backstage/ExtensionDefinition",
  versions: ["v1", "v2"]
});

export { OpaqueExtensionDefinition };
//# sourceMappingURL=InternalExtensionDefinition.esm.js.map
